import React from 'react';
import { setUserSession } from '../utils/Common';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import app from '../base/api';
const theme = createTheme();


class Login extends React.Component {

  constructor ({props, context}) {
    super();
    this.state = { user: {
        username: '',
        password: '',
      }
    };
  }

  handleChange = (event) => {
    let user = this.state.user;
    user[event.target.id] = event.target.value;
    this.setState({
      user: user
    });
  }


  handleLogin = async () => {
    var data = new FormData();
    data.append('username', this.state.user.username);
    data.append('password', this.state.user.password);
    let res = await app.post('/login', data, {})
    if (res && res.id) {
      setUserSession(res.id, res);
      this.props.navigate('/dashboard');
    }
  }

  render () {
      return (
        <ThemeProvider theme={theme}>
          <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
              sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                Ingresar
              </Typography>
              <Box noValidate sx={{ mt: 1 }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="username"
                  label="Usuario"
                  name="username"
                  value={this.state.user.username}
                  onChange={this.handleChange}
                  autoComplete="username"
                  autoFocus
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Contraseña"
                  type="password"
                  id="password"
                  value={this.state.user.password}
                  onChange={this.handleChange}
                  autoComplete="current-password"
                />
                <Button
                  type="button"
                  onClick={this.handleLogin}
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Ingresar
                </Button>
              </Box>
            </Box>
          </Container>
        </ThemeProvider>

      );
  }
}

// Wrapper component to provide navigate to Login
function LoginWithNavigate(props) {
  const navigate = useNavigate();
  return <Login {...props} navigate={navigate} />;
}

export default LoginWithNavigate;